import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

import App from "./App";
import Landing from "./Landing";
import { bootstrap } from "./auth";
import { muiTheme } from "./theme";
import "./styles.css";

// Three states this can land in:
//   1. Just signed in (URL has ?code=) → bootstrap() exchanges the code,
//      cleans the URL, returns true → render App.
//   2. Has stored session → bootstrap() returns true → render App.
//   3. No session → bootstrap() returns false → render Landing (user picks
//      Sign in / Sign up).
//
// App itself further gates on Cognito group membership: signed-in but
// not-yet-approved users see PendingApprovalView.
bootstrap()
  .then((isAuthenticated) => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          {isAuthenticated ? <App /> : <Landing />}
        </ThemeProvider>
      </StrictMode>,
    );
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error("auth bootstrap failed:", err);
    document.getElementById("root")!.innerHTML =
      `<div style="padding:24px;font-family:sans-serif"><h2>Authentication error</h2><pre>${String(err)}</pre><p><a href="/admin/">Try again</a></p></div>`;
  });
